export default __webpack_public_path__ + "static/media/head.7a664f3f.png";